import React from "react";
import { TextField, MenuItem, Box } from "@mui/material";

const PageSizeSelector = ({ pageSize, onChange }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        mt: 1,
        gap: 1,
        paddingRight: 2
      }}
    >
      <TextField
        select
        size="small"
        variant="outlined"
        label="Page Size"
        value={pageSize}
        onChange={onChange}
        sx={{ width: 120,
           
        }}
      >
        {[10, 25, 50, 100].map((size) => (
          <MenuItem key={size} value={size}>
            {size}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
};

export default PageSizeSelector;
